import React, { Component } from 'react';
import defaultLoader from '../home/images/loader.gif';
import {
  getDeliverTabLoading,
  stopDeliverTabLoading,
  subscribeDeliverTabLoading,
} from '../../utils/deliverTabLoading';
import { isDeliverPrescriptionPath } from '../../utils/productLicensing';
import './DeliverTabLoadingOverlay.css';

class DeliverTabLoadingOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: getDeliverTabLoading(),
    };
    this.unsubscribe = null;
    this.awayTimer = null;
  }

  componentDidMount() {
    this.unsubscribe = subscribeDeliverTabLoading((type) => {
      this.setState({ type: type || '' });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.type && !prevState.type) {
      this.scheduleAwayCheck();
    }
    if (!this.state.type && this.awayTimer) {
      clearTimeout(this.awayTimer);
      this.awayTimer = null;
    }
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    if (this.awayTimer) {
      clearTimeout(this.awayTimer);
    }
  }

  scheduleAwayCheck = () => {
    if (this.awayTimer) {
      clearTimeout(this.awayTimer);
    }
    this.awayTimer = setTimeout(() => {
      this.awayTimer = null;
      if (!getDeliverTabLoading()) {
        return;
      }
      const path =
        (typeof window !== 'undefined' && window.location.pathname) || '';
      if (!isDeliverPrescriptionPath(path)) {
        stopDeliverTabLoading();
      }
    }, 1500);
  };

  render() {
    if (!this.state.type) {
      return null;
    }
    return (
      <div className="deliver-tab-loading-overlay" aria-busy="true">
        <img
          className="deliver-tab-loading-overlay-image"
          src={defaultLoader}
          alt="Loading"
        />
      </div>
    );
  }
}

export default DeliverTabLoadingOverlay;



// WEBPACK FOOTER //
// ./src/components/common/DeliverTabLoadingOverlay.js